<template>
  <main class="page-main">
    <banner />

    <card />

    <service />

    <season />

    <report :prev-route="prevRoute" />

    <fonts />
  </main>
</template>
<script>
import observer from '@/mixins/observer'

export default {
  components: {
    banner: () => import('@/views/main/Banner'),
    card: () => import('@/views/main/Card'),
    service: () => import('@/views/main/Service'),
    season: () => import('@/views/main/Season'),
    report: () => import('@/views/main/Report'),
    fonts: () => import('@/views/main/Fonts'),
  },
  mixins: [observer],
  data () {
    return {
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.name
    })
  }
}
</script>
